import { useMutation } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { UpdatePasswordRequestDto } from '@/features/account/types/account-dto';
import EToast from '@/components/everridge/EToast';
import { t } from 'i18next';

type Props = {
  onError?: (message: string) => void;
} & ApiHookProps;

export const useUpdatePasswordApi = ({ onError }: Props = {}) => {
    const axiosInstance = useAxiosAuth();

    const {
        mutateAsync: updatePassword, 
        isPending: isUpdatingPassword, 
        isError: isErrorUpdatingPassword
    } = useMutation({
        mutationFn: async (dto: UpdatePasswordRequestDto) => {
            const response = await axiosInstance.put(
                ApiConfig.queries.features.settings.endpoints.updatePassword, dto
            );  
            return response.data;
        },
        onSuccess: async () => {   
          EToast({
              variant: 'success',
              message: t('Successfully change account password.'), 
          });            
        },
        onError: (error: any) => {
          const errorMessage = error.response?.data.errors.ERR_INVALID_CURRENT_PASSWORD[0];

          onError?.(errorMessage);

          EToast({
              variant: 'error',
              message: t('Error occurred during changing account password. Try again later.'), 
          });
        }
    });

    return {
      updatePassword, 
      isUpdatingPassword, 
      isErrorUpdatingPassword
    }
};